import styled from 'styled-components';

export const CreateByButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 20px;
`;
